export const getLemonadeAppLink = (isMobile: boolean): string =>
  `<a href="${
    isMobile ? 'http://onelink.to/a49df2' : 'https://www.lemonade.com/download'
  }" target="_blank">Lemonade app</a>`;
